export const HIGHLIGHTED_TEXT = {
  pending: 'Para prosseguir, você precisa informar o seu responsável.',
  submitted: 'Sua solicitação de liberação está em andamento.',
}

export const SECONDARY_TEST = {
  pending:
    'Informe abaixo os dados para podermos entrar em contato com a pessoa responsável legal pelo seu plano. Quando aceito o termo pelo responsável, você poderá acessar a plataforma.',
  submitted:
    'Caso a liberação já tenha sido feita, clique no botão “Meu responsável já liberou” ou continue aguardando o seu acesso a plataforma.',
}
